<div class="space-y-sm">
  @for (file of files(); track file.fileKey) {
    <a
      class="relative block transform cursor-pointer rounded-3 bg-grey-200 p-sm hover:bg-grey-100"
      [ngClass]="{'bg-president-400 text-grey-50 hover:bg-president-300': invert()}"
      [href]="file.url"
      bgoOpenNewTab
    >
      <span class="flex space-x-md">
        <span class="w-[50px] text-center">
          @if (file | cftIsImage) {
            <img
              [ngSrc]="file.url"
              height="50"
              width="50"
              ngSrcset="100w, 200w"
              [alt]="file.name"
              class="h-[50px] w-[50px] rounded-1 object-cover"
            />
          } @else if (file | cftIsPdf) {
            <fa-icon [icon]="pdfIcon" size="2x"></fa-icon>
          } @else {
            <fa-icon [icon]="otherFileIcon" size="2x"></fa-icon>
          }
        </span>
        <span class="flex grow items-center space-y-2xs">
          <span>
            <span class="line-clamp-1 break-all">{{ file.name }}</span>
            <span class="line-clamp-1 text-xs text-grey-500">{{ file.fileKey | cftFileExtension | uppercase }}</span>
          </span>
        </span>
      </span>
    </a>
  }
</div>
